// Lazy GDACS footprint for the selected hazard. Nothing is fetched until an event is selected.
import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { geometryQueryOptions, derivePanelStatus, pathMeta, isAllowedGeometryUrl } from '../gdacs/geometryQuery';

export const useEventGeometry = (event) => {
  const query = useQuery(geometryQueryOptions(event));
  const url = isAllowedGeometryUrl(event?.urls?.geometry) ? event.urls.geometry : null;
  const triedRef = useRef(null);
  // One automatic attempt per new advisory URL (the query is keyed by event id, so the old path stays
  // on screen meanwhile); the Retry button covers a failed attempt.
  useEffect(() => {
    const d = query.data;
    if (!url || !d || String(d.eventId) !== String(event?.id) || d.sourceUrl === url || triedRef.current === url) return;
    triedRef.current = url;
    query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, query.data, event?.id]);
  const status = derivePanelStatus({ event, query });
  return {
    parsed: status === 'ready' ? query.data : null,
    status,
    meta: pathMeta({ event, query }),
    refetch: query.refetch,
  };
};
